import ServiceArea from '@/services/api/serviceArea';

export default {
  namespaced: true,
  state: {
    serviceAreas: [],
    serviceArea: {},
  },
  getters: {
    serviceAreas: state => state.serviceAreas,
    serviceArea: state => state.serviceArea,
  },
  mutations: {
    setServiceAreas: (state, payload) => {
      state.serviceAreas = payload;
    },
    setServiceArea: (state, payload) => {
      state.serviceArea = payload;
    },
  },
  actions: {
    getServiceAreas (state, options = {}) {
      return new Promise((resolve, reject) => {
        ServiceArea.getServiceAreas(options)
          .then(({ data }) => {
            state.commit('setServiceAreas', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getServiceArea (state, id) {
      return new Promise((resolve, reject) => {
        ServiceArea.getServiceArea(id)
          .then(({ data }) => {
            state.commit('setServiceArea', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createServiceArea (state, params) {
      return new Promise((resolve, reject) => {
        ServiceArea.createServiceArea(params)
          .then(({ data }) => resolve(data))
          .catch(e => reject(e));
      });
    },
    updateServiceArea (state, { id, data }) {
      return new Promise((resolve, reject) => {
        ServiceArea.updateServiceArea(id, data)
          .then(({ data }) => {
            state.commit('setServiceArea', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteServiceArea (state, id) {
      return new Promise((resolve, reject) => {
        ServiceArea.deleteServiceArea(id)
          .then(response => resolve(response))
          .catch(e => reject(e));
      });
    },
  },
};
